'use client';

import { useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { BasicInfoPrizesField } from '@/features/tournament-wizard/blocks';

interface EditPrizesModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentPrizes: string;
  onSave: (newPrizes: string) => Promise<boolean>;
  isLoading: boolean;
}

export function EditPrizesModal({
  isOpen,
  onClose,
  currentPrizes,
  onSave,
  isLoading,
}: EditPrizesModalProps) {
  const [prizes, setPrizes] = useState(currentPrizes);

  const handleSave = async () => {
    await onSave(prizes);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Premios"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <BasicInfoPrizesField
          value={prizes}
          onChange={setPrizes}
          wrapInCard={false}
        />
      </div>
    </EditModal>
  );
}
